// extracted by mini-css-extract-plugin
export default {"productColour":"L3V0U","colourTitle":"iXWkL","leavesden2":"hEVA6","leavesden3":"WuhID","colourValue":"aKxaq","withinCarouselFacets":"MvPsa"};